import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUser } from "../../models/User";

interface IUserProfileState {
  isAuthorized: boolean | null;
  user: IUser | null;
}

const initialState: IUserProfileState = {
  isAuthorized: null,
  user: null,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<IUser>) => {
      state.isAuthorized = true;
      state.user = action.payload;
    },
    logout: (state) => {
      state.isAuthorized = false;
      state.user = null;
    },
    updateProfileImage: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.profileImagePath = action.payload;
      }
    },
    updateProfile: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
    },
  },
});

export const { login, logout, updateProfileImage, updateProfile } = userProfileSlice.actions;

export default userProfileSlice.reducer;
